export default __webpack_public_path__ + "static/media/avitar.2f56bf08.png";